import { render, staticRenderFns } from "./ModalOrderConfirmation.vue?vue&type=template&id=73b14fea&"
import script from "./ModalOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalOrderConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports